export const apiResponseType = {
  $schema: "http://json-schema.org/draft-07/schema#",
  $ref: "#/definitions/Datas",
  definitions: {
    Datas: {
      type: "array",
      items: {
        $ref: "#/definitions/DataType",
      },
    },
    DataType: {
      type: "object",
      properties: {
        id: {
          type: "number",
        },
        countryName: {
          type: "string",
        },
        countryKey: {
          type: "string",
        },
        canTravel: {
          type: "boolean",
        },
        isTravelBubble: {
          type: "boolean",
        },
        recoveryGuide: {
          type: ["null", "string"],
        },
        published_at: {
          type: "string",
        },
        created_at: {
          type: "string",
        },
        updated_at: {
          type: "string",
        },
        countryFlag: {
          type: "string",
        },
        source: {
          type: ["null", "string"],
        },
        view: {
          type: "number",
        },
        linkType: {
          $ref: "#/definitions/LinkType",
        },
        latest_at: {
          type: "string",
        },
        iso_code: {
          type: "string",
        },
        airport: {
          type: ["null", "string"],
        },
        cover_image: {
          type: ["null", "string"],
        },
        notice: {
          anyOf: [
            {
              $ref: "#/definitions/Notice",
            },
            {
              type: "null",
            },
          ],
        },
        summaryEntrance: {
          anyOf: [
            {
              $ref: "#/definitions/Summary",
            },
            {
              type: "null",
            },
          ],
        },
        vaccination: {
          anyOf: [
            {
              $ref: "#/definitions/Vaccination",
            },
            {
              type: "null",
            },
          ],
        },
        no_vaccination: {
          anyOf: [
            {
              $ref: "#/definitions/Vaccination",
            },
            {
              type: "null",
            },
          ],
        },
        summaryReturn: {
          anyOf: [
            {
              $ref: "#/definitions/Summary",
            },
            {
              type: "null",
            },
          ],
        },
        location: {
          $ref: "#/definitions/Location",
        },
        cities: {
          type: "array",
          items: {
            $ref: "#/definitions/City",
          },
        },
        covid_vaccines: {
          type: "array",
          items: {
            $ref: "#/definitions/Covid",
          },
        },
        histories: {
          type: "array",
          items: {
            $ref: "#/definitions/History",
          },
        },
      },
      required: [
        "id",
        "countryName",
        "countryKey",
        "canTravel",
        "isTravelBubble",
        "recoveryGuide",
        "published_at",
        "created_at",
        "updated_at",
        "countryFlag",
        "source",
        "view",
        "linkType",
        "latest_at",
        "iso_code",
        "airport",
        "cover_image",
        "notice",
        "summaryEntrance",
        "vaccination",
        "no_vaccination",
        "summaryReturn",
        "location",
        "cities",
        "covid_vaccines",
        "histories",
      ],
      additionalProperties: false,
    },
    LinkType: {
      type: "string",
      enum: ["cities", "countries"],
    },
    Notice: {
      type: "object",
      properties: {
        id: {
          type: "number",
        },
        title: {
          type: "string",
        },
        contents: {
          type: "string",
        },
      },
      required: ["id", "title", "contents"],
      additionalProperties: false,
    },
    Summary: {
      type: "object",
      properties: {
        id: {
          type: "number",
        },
        vaccination: {
          $ref: "#/definitions/SummaryEntranceNoVaccination",
        },
        no_vaccination: {
          $ref: "#/definitions/SummaryEntranceNoVaccination",
        },
      },
      required: ["id", "vaccination", "no_vaccination"],
      additionalProperties: false,
    },
    SummaryEntranceNoVaccination: {
      type: "object",
      properties: {
        id: {
          type: "number",
        },
        period: {
          type: "number",
        },
        covid_isolation: {
          $ref: "#/definitions/Covid",
        },
      },
      required: ["id", "period", "covid_isolation"],
      additionalProperties: false,
    },
    Covid: {
      type: "object",
      properties: {
        id: {
          type: "number",
        },
        code: {
          anyOf: [
            {
              $ref: "#/definitions/Code",
            },
            {
              $ref: "#/definitions/IsolationCode",
            },
          ],
        },
        name: {
          $ref: "#/definitions/Name",
        },
      },
      required: ["id", "code", "name"],
      additionalProperties: false,
    },
    Code: {
      type: "string",
      enum: ["az", "janssen", "moderna", "pfizer"],
    },
    IsolationCode: {
      type: "string",
      enum: ["NEED", "NO", "NO_ENTRANCE", "NO_NEGATIVE"],
    },
    Name: {
      type: "string",
      enum: ["아스트라제네카", "얀센", "모더나", "화이자"],
    },
    Vaccination: {
      type: "object",
      properties: {
        id: {
          type: "number",
        },
        entrance: {
          $ref: "#/definitions/Entrance",
        },
        return: {
          $ref: "#/definitions/Entrance",
        },
        entrance_prepare: {
          type: "array",
          items: {
            $ref: "#/definitions/PrepareLink",
          },
        },
        retrun_prepare: {
          type: "array",
          items: {
            $ref: "#/definitions/PrepareLink",
          },
        },
      },
      required: [
        "id",
        "entrance",
        "return",
        "entrance_prepare",
        "retrun_prepare",
      ],
      additionalProperties: false,
    },
    Entrance: {
      type: "object",
      properties: {
        id: {
          type: "number",
        },
        isolation: {
          type: "string",
        },
        covidCheck: {
          type: "string",
        },
        visa: {
          type: "string",
        },
        process: {
          type: ["null", "string"],
        },
      },
      required: ["id", "isolation", "covidCheck", "process"],
      additionalProperties: false,
    },
    PrepareLink: {
      type: "object",
      properties: {
        id: {
          type: "number",
        },
        label: {
          type: "string",
        },
        url: {
          type: "string",
        },
      },
      required: ["id", "label", "url"],
      additionalProperties: false,
    },
    Location: {
      type: "object",
      properties: {
        id: {
          type: "number",
        },
        latitude: {
          type: "number",
        },
        longitude: {
          type: "number",
        },
      },
      required: ["id", "latitude", "longitude"],
      additionalProperties: false,
    },
    City: {
      type: "object",
      properties: {
        id: {
          type: "number",
        },
        name: {
          type: "string",
        },
        image: {
          type: ["null", "string"],
        },
        link: {
          type: "string",
        },
      },
      required: ["id", "name", "image", "link"],
      additionalProperties: false,
    },
    History: {
      type: "object",
      properties: {
        new_cases: {
          type: ["number", "null"],
        },
        new_cases_weekly: {
          type: ["number", "null"],
        },
        vaccination_rate: {
          type: ["number", "null"],
        },
        update_date: {
          type: "string",
        },
      },
      required: [
        "new_cases",
        "new_cases_weekly",
        "vaccination_rate",
        "update_date",
      ],
      additionalProperties: false,
    },
  },
};
